import { render, staticRenderFns } from "./ViewDemolitions.vue?vue&type=template&id=600955ae"
import script from "./ViewDemolitions.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDemolitions.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports